import { render, staticRenderFns } from "./PriceModifier.vue?vue&type=template&id=1eb09862&scoped=true"
import script from "./PriceModifier.vue?vue&type=script&lang=js"
export * from "./PriceModifier.vue?vue&type=script&lang=js"
import style0 from "./PriceModifier.vue?vue&type=style&index=0&id=1eb09862&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb09862",
  null
  
)

export default component.exports